import { Button, Form, Input, notification, Select, Upload } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import liracrypt from '../../components/Liracrypt/liracrypt';
import { LoadingOutlined } from "@ant-design/icons";

const ImgUpload = ({
    form,
    labelCol,
    label,
    name,
    required,
    data,
    height,
    disabled,
    rowData
}) => {
    const [img, setImg] = useState();
    const [isResponseImg, setIsRespImg] = useState(false);
    const imgInputRef = useRef();
    const [currentValue, setCurrentValue] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (currentValue === '') {
            setImg(null);
        }
    }, [currentValue]);


    const handleDrop = (e) => {
        e.nativeEvent.preventDefault()
        if (!e) return;
        const files = e.nativeEvent.dataTransfer.files;
        if (!files[0]) return;
        if (files[0].type.includes('image/')) {
            setImg(files[0]);
            form.setFieldsValue({ [name]: files[0] });
        } else {
            notification.error({ message: 'Please Select image file only' })
        }
    };

    const getClickedImage = (e) => {
        if (!e.target.files[0]) return;
        if (e.target.files[0].type.includes('image/')) {
            setImg(e.target.files[0]);
            form.setFieldsValue({ [name]: e.target.files[0] });
        } else {
            notification.error({ message: 'Please Select image file only' })
        }
    }

    const resetImg = () => {
        form.setFieldsValue({ [name]: isResponseImg ? null : '' });
        imgInputRef.current.value = '';
        setImg(null)
    };

    useEffect(() => {
        if (data.hasImage) {
            let urlData = {...data.params};
            if(data.props){
                urlData[data.props] = rowData[data.props];
            }
            setLoading(true);
            liracrypt.get(data.api, urlData)
                .then(response => {
                    setImg(response.data.data);
                    setIsRespImg(true);
                    form.setFieldsValue({ [name]: 'noChange' });
                    setLoading(false);
                })
                .catch(err => {
                    console.error(err);
                    setLoading(false);
                })
        }
    }, []);


    return (
        <>
            <Form.Item
                labelCol={{span: labelCol || 8}}
                getValueProps={(e) => setCurrentValue(e)}
                name={name}
                style={{cursor: disabled? 'not-allowed': 'normal'}}
                label={label}
                initialValue=""
                rules={[
                    {
                        required: required,
                        message: 'Please add image',
                    },
                ]}
            >

                {
                    loading ?
                        <>
                            <LoadingOutlined
                                style={{ fontSize: 80, color: "#dc3545" }}
                                spin
                            />
                        </> :
                        img ? (
                            <div className='uploaded-img'>
                                <div className={"img"} style={{ maxHeight: height }}>
                                    <img
                                        src={typeof (img) === 'string' ? img : URL.createObjectURL(img)}
                                    />
                                </div>
                                {
                                    !disabled && (
                                        <div className='img-delete-icon'>
                                            <div style={{ marginRight: 20 }} onClick={() => { imgInputRef.current.click() }}>
                                                <span>
                                                    <EditOutlined className="img-edit" />
                                                </span>
                                            </div>
                                            <div onClick={resetImg}>
                                                <span>
                                                    <DeleteOutlined className="img-trash" />
                                                </span>
                                            </div>
                                        </div>
                                    )
                                }

                            </div>
                        ) :
                            <div onDragOver={e => e.preventDefault()} onDrop={handleDrop} onClick={() => { imgInputRef.current.click() }} className='upload-image' style={{ minHeight: height, pointerEvents: disabled ? 'none': '' }}>
                                <Button type='link' style={{ color: ' #777777' }}>Click To Upload</Button>
                            </div>
                }
            </Form.Item>
            <input className='hidden-input' accept='.png, .jpg, .jpeg' ref={imgInputRef} type="file" style={{ visibility: 'hidden' }} onChange={getClickedImage} />
        </>
    )
};

export default ImgUpload;